export const ConflictErrorMessage = 'Data has been changed. Please refresh the page to see the latest changes.';
export const GeneralErrorMessage = 'An error occurred. Please try again later or contact Support.';